<template>
  <div class="container premium-required">
    <h1>
      This content is only available for Premium users.
    </h1>
    <router-link :to="{name:'Home'}">
      <button class="btn btn-primary">
        Back to Toolkit Home
      </button>
    </router-link>
  </div>
</template>

  <script>
  export default {
    name: 'PremiumRequired',
  };
  </script>

  <style scoped>
  .premium-required{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    width: 100%;
  }
  .premium-required button {
    margin: 2rem;
  }
  </style>